



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreIPPage extends Base {
    public form: any = {};
    public presetAccountsFields: Array<VFields<any>> = [];
    public presetAccountsModel = {
        id:'',
        name:'',
        accountNumber: [],
    };
    public storeId: number = 0;
    public requestProgress: boolean = false;
    public presetId :string;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'PresetAccounts' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'savePresetAccounts') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.savePresetAccounts();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.presetId = this.$route.params.presetId;
    this.setPresetAccountsFields();

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if(this.$route.params.presetId){
        this.getPresetAccounts();
    }
  }

  public setPresetAccountsFields(): void {
    this.presetAccountsFields = [
        {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: 'Preset Name',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Preset Name', v),
          ]
        },
      },
      {
        key: 'accountNumber',
        type: 'v-alynk-textchip',
        required: true,
        templateOptions: {
          label: 'Preset Accounts',
          multiple: true,
          required: true,
          items: this.presetAccountsModel.accountNumber,
          disabled: false,
          loading: false,
          rules:[
            v =>this.requiredForArray('Preset Accounts', v)
          ],
          events: {
            onChange: (items, value) => {
              const index = this.presetAccountsModel.accountNumber.indexOf(value);
              if (index > -1) {
                this.presetAccountsModel.accountNumber.splice(index, 1);
              }
            },
            onRemove: (item, value) => {
              const index = this.presetAccountsModel.accountNumber.indexOf(value);
              if (index > -1) {
                this.presetAccountsModel.accountNumber.splice(index, 1);
              }
            },
          },
        },
      },
    ];
  }

    public async getPresetAccounts(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.presetAccountsFields);
            const response = await storeService.getPresetAccountsByStore(this.storeId);
            const selectedPreset =  response.storeJson.presets.find(
                (m) => m.id == this.$route.params.presetId
            );
            this.presetAccountsModel = selectedPreset;
        } finally {
            this.formlyHideSkeleton(this.presetAccountsFields);
        }
    }

    public validatePresetAccounts(): Vue & { validate: () => boolean } {
        return this.$refs.presetAccountsForm as Vue & { validate: () => boolean };
    }

    public async savePresetAccounts(): Promise<void>{
        if(this.validatePresetAccounts().validate()){
            try{
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                if (this.presetId == undefined) {
                    this.presetAccountsModel.id = Utils.newGuid();
                    await storeService.savePresetAccounts(this.storeId, this.presetAccountsModel);
                    this.showAlert(true, 'Preset Account Added successfully');
                    this.$router .push({
                      name: 'admin.stores.edit',
                      params:{
                        tab: 'PresetAccounts'
                      }
                    })
                    .catch((ex) => {
                        console.log(ex);
                    });
                }else{
                    await storeService.updatePresetAccounts(this.storeId, this.presetAccountsModel);
                    this.showAlert(true, 'Preset Accounts Updated successfully');
                    this.$router .push({
                        name: 'admin.stores.edit',
                        params: {
                          storeId: this.storeId.toString(),
                          tab: 'PresetAccounts'
                        },
                    })
                    .catch((ex) => {
                        console.log(ex);
                    });
                }
            }finally{
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }
}
